"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storyUrlFormat = exports.StoryKey = void 0;
/** @description used as a resource locator for stories stored in S3 and served by
 *  the svs-publisher pipeline backend
 *
 * The story key is composed of an address and an id.  The address is either a user's wallet
 * or the 0x0 address for anonymous shares.
 *
 * The id is either
 *   1. For user wallet stories, the id is a sequential numeric id starting from 1 for the first story
 *   2. For anonymous shares, the id is a sha256 hash of the story content, represented as a hext-encoded utf8 string
 */
class StoryKey {
    constructor(prefix, address, id, suffix = 'json', infix) {
        this.prefix = prefix;
        this.suffix = suffix;
        this.infix = infix;
        this.address = address;
        this.id = id.toString();
    }
    /** @return the full story key path */
    toString() {
        let suffix = this.suffix
            ? '.' + this.suffix
            : '';
        if (this.address !== '0x0' && suffix === '.json') {
            suffix = `/dialog${suffix}`;
        }
        return `${this.prefix}/${this.rawKey()}${suffix}`;
    }
    /** @returns the address and id, without prefix or suffix */
    rawKey() {
        if (this.infix) {
            return `${this.address}/${this.infix}/${this.id}`;
        }
        return `${this.address}/${this.id}`;
    }
    /** @returns a copy of this storyKey with a different prefix */
    withPrefix(prefix) {
        return new StoryKey(prefix, this.address, this.id, this.suffix);
    }
    /** @returns a copy of this storyKey with a different suffix */
    withSuffix(suffix) {
        return new StoryKey(this.prefix, this.address, this.id, suffix);
    }
}
exports.StoryKey = StoryKey;
function storyUrlFormat(viewerUrl, walletAddress, storyId, tokenId) {
    return `https://${viewerUrl}/${walletAddress}/n/${storyId}/${tokenId}`;
}
exports.storyUrlFormat = storyUrlFormat;
//# sourceMappingURL=StoryApi.js.map